export const c_form_m_horizontal__group_label_md_PaddingTop = {
  "name": "--pf-c-form--m-horizontal__group-label--md--PaddingTop",
  "value": "calc((((((1rem * 1.5) + (2 * 1px)) - 1rem) / 2) + 1rem) - ((((0.875rem * 1.3) - 0.875rem) / 2) + 0.875rem) + 1px)",
  "var": "var(--pf-c-form--m-horizontal__group-label--md--PaddingTop)"
};
export default c_form_m_horizontal__group_label_md_PaddingTop;